export const PRESETS = [
    { value: "aggressive", label: "Aggressive", icon: "⚡", desc: "Max damage output", color: "#ef4444" },
    { value: "balanced", label: "Balanced", icon: "◈", desc: "Attack & survive", color: "#7c3aed" },
    { value: "defensive", label: "Defensive", icon: "🛡", desc: "Outlast the enemy", color: "#22c55e" },
];
export const PRESET_VALUES = PRESETS.map(p => p.value);
